import React from 'react';
import styled from 'styled-components';
import { editorIcModeEdit24px  } from '@ey/motif-react-wrapper/assets/icons/index';

import Button from '../../../../../BaseComponentWrappers/MotifButton';
import { labels } from '../../../../../../../util/utils';

export default function ControlPropertiesButton(props) {
    const { handleOnClick, disabled } = props;

    return (
        <StyledControlPropertiesButton className="ControlPropertiesButton">
            <Button
                variant="text-alt"
                type="button"
                className="controlProperties-motifButton"
                iconSource={editorIcModeEdit24px}
                showLabel
                showIcon
                disabled={disabled}
                isEllipsed
                buttonLabel={labels.editControl}
                noOfLines={1}
                onClick={handleOnClick}
            />
        </StyledControlPropertiesButton>
    );
}

const StyledControlPropertiesButton = styled.section`
    .controlProperties-motifButton {
        font-size: var(--px-16);
    }
`;
